const availableAliases = ["面料A", "面料B", "面料C", "面料D", "面料E", "面料F", "面料G", "面料H", "面料I", "面料J"];

export function processMaterials(val, userModifiedIndex = -1) {
    // console.log('传入的materials', val);
    const materials = JSON.parse(val);
    const usedAliases = [];

    // Step 1: 收集所有合法 alias（排除用户刚设置的那一项）
    materials.forEach((item, index) => {
        if (index === userModifiedIndex) return; // 跳过刚修改的项
        if (item.alias && availableAliases.includes(item.alias)) {
            usedAliases.push(item.alias);
        }
    });

    // Step 2: 自动为缺失 alias 或非法 alias 的项分配未被使用的 alias
    materials.forEach((item, index) => {
        if (index === userModifiedIndex) return; //  跳过刚修改的项

        if (!item.alias || !availableAliases.includes(item.alias)) {
            const availableAlias = availableAliases.find(alias => !usedAliases.includes(alias));
            if (availableAlias) {
                item.alias = availableAlias;
                usedAliases.push(availableAlias);
            }
        }
    });

    // Step 3: 再次遍历兜底去重（排除用户刚修改的项）
    const finalUsed = [];

    // 先把用户修改的项加入 finalUsed，防止它被覆盖
    if (userModifiedIndex >= 0 && userModifiedIndex < materials.length) {
        const userItem = materials[userModifiedIndex];
        if (userItem.alias && availableAliases.includes(userItem.alias)) {
            finalUsed.push(userItem.alias);
        }
    }

    materials.forEach((item, index) => {
        if (index === userModifiedIndex) return; // 跳过刚修改的项

        while (finalUsed.includes(item.alias)) {
            const available = availableAliases.find(a => !finalUsed.includes(a));
            if (available) {
                item.alias = available;
            }
        }
        finalUsed.push(item.alias);
    });

    // Step 4: 根据 alias 升序排序
    materials.sort((a, b) => a.alias.localeCompare(b.alias));

    return materials;
}


export function assignAndSortMaterials(materials, newItem) {
    const usedAliases = materials.map(item => item.alias);

    // Step 1: 分配 alias
    let assignedAlias = null;

    for (const alias of availableAliases) {
        if (!usedAliases.includes(alias)) {
            assignedAlias = alias;
            break;
        }
    }

    const itemWithAlias = {
        ...newItem,
        alias: assignedAlias || '未知'
    };

    // Step 2: 插入新项
    const newList = [...materials, itemWithAlias];

    // Step 3: 再次去重兜底
    const finalUsed = [];
    newList.forEach((item) => {
        while (finalUsed.includes(item.alias)) {
            const available = availableAliases.find(a => !finalUsed.includes(a));
            if (available) {
                item.alias = available;
            }
        }
        finalUsed.push(item.alias);
    });

    // Step 4: 排序（按 alias 升序）
    return newList.sort((a, b) => a.alias.localeCompare(b.alias));
}
